<template>
    <div>
        <first />
        <second />
        <third />
        <fourth />
        <fifth />
        <sixth />
    </div>
</template>

<script src="./manufacturing.js"></script>
<style src="./manufacturing.css"></style>